import { FC, memo } from 'react';
import NextImage from 'next/image';
import { Grid, Box, Typography } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import { Loader } from '@keaze/web/components/Loader';
import { Select } from '@keaze/web/components/select';
import { GoogleSearchAutocomplete } from '@keaze/web/components/googleSearchAutocomplete';
import { FilterOnChange } from '@keaze/web/components/filters';
import { MobileFiltersData, SearchFilters } from '../filters.types';
import styled from 'styled-components';
import {
  IconButton,
  IconXButton,
  Header,
  ShowListingsButton,
  NumberOfActiveFilters,
  ClearAllButtonWrapper,
  ClearAllButton,
} from './mobile.styles';
import { Drawer } from './drawer/drawer';
import { Groups, Group } from '../groups';
import { renderMenuItemSelect, setEmptySelectValue } from '../helpers';
import { MoreFilters } from '../moreFilters';
import { useMobile } from './mobile.hook';
import { RadiusData } from './mobile.types';

type Props = {
  googleSearchValue: string;
  radius: RadiusData;
  data: MobileFiltersData[];
  isLoading: boolean;
  onChange: FilterOnChange;
};

const S = {
  groupsCont: styled(Groups)`
     {
    }
  `,

  filtersCont: styled.div`
     {
      ${({ theme: { colors } }) => `
    .MuiFormLabel-root {
      font-size: 14px !important;
      color: ${colors.whites.white1} !important;
    }
    .MuiInputBase-root {
      svg path {fill: ${colors.greens.green3} !important;}
      .MuiSelect-select:focus { 
    
        padding: 10px 40px 10px 20px !important;
        background-color:  ${colors.whites.white1} !important;
  
        p {
        color:  ${colors.greens.green3} !important;
   
        }
      }
      &.Mui-focused {

      border: transparent !important;
      border-radius: 3px !important;
        background-color:  ${colors.whites.white1} !important;
      }
      p {    color:  ${colors.whites.white1}  !important;}
      border: 1px solid  ${colors.whites.white1} ;
     
      svg {margin-top: 5px;}
      svg path {fill: ${colors.golds.gold1} !important;}
      background-color:transparent !important;
      
    }
    `}
    }
  `,

  searchRadius: styled(Group)`
     {
      ${({ theme: { colors } }) => `
  display: flex;
  background-color: ${colors.whites.white1};
  flex-direction: row;
  align-items: center;
  border-radius: 3px;
  padding: 0 !important;
  height: 40px;
  .MuiInputBase-root .MuiSelect-select:focus { padding: 0 !important;}

`}
    }
  `,
  searchField: styled(Box)`
     {
      ${({ theme: { colors } }) => `
  width: 70%;
  border-radius: 3px !important;
  background-color: ${colors.whites.white1};
  height: 40px;
  margin-bottom: 0;
  .Mui-focused {border: 0 !important}
  .MuiFormControl-root {
    
    .MuiInputBase-root {  border-radius: 3px !important; height: 40px !important; background-color: ${colors.whites.white1}; border:0 !important;}
    height: 40px !important;
    border-radius: 3px !important;

  }
  .MuiAutocomplete-input {
    border: 1px solid white !important;
    background-color: ${colors.whites.white1};
  }
  `}
    }
  `,

  radiusField: styled(Select)`
     {
      ${({ theme: { colors } }) => `
  width: 30%;
  border: 0 !important;
  padding: 0; 
  height: 20px;
  display: block;

  .MuiSelect-nativeInput {

    color: ${colors.greens.green7};
    font-size: 10px;
    padding: 0 5px;

  }
  .MuiSelect-select {
    padding: 0;
  }
  .MuiInput-root {
    p {font-size: 12px;  color:${colors.greens.green3} !important}
    padding: 0; 
  
    height:20px;
   border: 0 !important;
  }
  .MuiSelect-selectMenu {
    border: 0;
    background-color: ${colors.whites.white1};
    font-size: 10px;
  }

`}
    }
  `,

  FilterContainer: styled.div`
     {
      svg path {
        fill: yellow !important;
      }
      margin-top: 15px;
      color: #fff;
      display: flex;
      justify-content: space-between;
      width: 100%;

      ${({ theme: { colors } }) => `
h1 {color:  ${colors.whites.white1}; font-size: 21px;}
button {
  color:  ${colors.whites.white1};
  text-decortation: underline;}
`}
    }
  `,

  logo: styled.div`
     {
      ${({ theme: { colors } }) => `
width:120px;
height: 40px;
    background-color: ${colors.whites.white1};
    -webkit-mask: url( /svg/SHS-logo.svg) no-repeat center;
    mask: url( /svg/SHS-logo.svg) no-repeat center;
  
`}
    }
  `,

  filterLogo: styled.div`
     {
      ${({ theme: { colors } }) => `
width:18px;
height: 21px;
    background-color: ${colors.golds.gold1};
    -webkit-mask: url( /svg/filter_alt.svg) no-repeat center;
    mask: url( /svg/filter_alt.svg) no-repeat center;
  
`}
    }
  `,

  logoCont: styled.div`
     {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
  `,

  filterText: styled.p`
     {
      ${({ theme: { colors } }) => `
   font-size:16px;
    color: ${colors.whites.white1}
   
    `}
    }
  `,

  leftContiner: styled.div`
     {
      ${({ theme: { colors } }) => `
    &:before {
      content: '';
        position: absolute;
        top: 0;
        right: 0 !important;
        background-color:${colors.greens.green3} !important;
        left: -16px;
        width: 100vw;
        height: 100%;
        background-color: #fff;
        z-index: -1;
      `}
    }
  `,

  mainContainer: styled(Grid)`{
    ${({ theme: { colors } }) => `
    &:before {
      content: '';
        position: absolute;
        top: 0;
        left: 0 !important;
        background-color:${colors.greens.green3} !important;
        left: -16px;
        width: 100vw;
        height: 100%;
  
        z-index: -1;
      }
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  
    background-color: ${colors.greens.green3};
    padding:15px 0 10px 0;
  
    .MuiAutocomplete-fullWidth {height: 35px; padding:0 !important}
    .MuiAutocomplete-input  {
      border-radius: 3px !important;
      // height: 100% !important;
      padding: 8px 4px 9px 4px !important;
      
     
    
    }


    .MuiIconButton-label {
      justify-content: space-between !important;
      svg  {   fill: ${colors.greys.greys19} !important;  background-color: ${colors.whites.white1}; margin-top:2px}
    }
  },
  


  `},
  


`,
};

export const MobileFilters: FC<Props> = memo(
  ({ googleSearchValue, radius, data, isLoading, onChange }) => {
    const {
      drawerOpen,
      numberOfActiveFilters,
      toggleDrawer,
      onClearAllFilters,
      onClearFilter,
    } = useMobile({ data, radius, onChange });

    const googleSearch = (
      <GoogleSearchAutocomplete
        withIcon
        value={googleSearchValue}
        onChange={(value) => onChange(SearchFilters.Location, value)}
      />
    );

    return (
      <>
        <S.leftContiner>
          <S.mainContainer container wrap="nowrap">
            {googleSearch}
            <IconButton aria-label="close" onClick={toggleDrawer}>
              <S.filterText>Filters</S.filterText>
              <S.filterLogo>&nbsp;</S.filterLogo>
              {/* <NextImage src="/svg/filter.svg" width={18} height={21} /> */}
              {numberOfActiveFilters !== 0 && (
                <NumberOfActiveFilters>
                  {numberOfActiveFilters}
                </NumberOfActiveFilters>
              )}
            </IconButton>
          </S.mainContainer>
        </S.leftContiner>

        <Drawer open={drawerOpen} onClose={toggleDrawer}>
          <Header container justifyContent="space-between" alignItems="center">
            <S.logoCont>
              <S.logo>&nbsp;</S.logo>

              <IconXButton aria-label="close" onClick={toggleDrawer}>
                <CloseIcon />
              </IconXButton>
            </S.logoCont>

            <S.FilterContainer>
              <Typography variant="h1">Filters</Typography>
              <ClearAllButtonWrapper>
                <ClearAllButton onClick={onClearAllFilters}>
                  Clear all filters
                </ClearAllButton>
              </ClearAllButtonWrapper>
            </S.FilterContainer>
          </Header>

          <S.groupsCont>
            <S.filtersCont>
              <S.searchRadius>
                <S.searchField mb={0.25}>{googleSearch}</S.searchField>
                <S.radiusField
                  name={SearchFilters.Radius}
                  value={setEmptySelectValue(radius.value)}
                  data={radius.data}
                  placeholder="Radius"
                  renderMenuItem={renderMenuItemSelect}
                  onChange={({ target: { name, value } }) =>
                    onChange(name as string, value as string)
                  }
                />
              </S.searchRadius>

              <MoreFilters
                data={data}
                onChange={onChange}
                onClear={onClearFilter}
              />
            </S.filtersCont>
          </S.groupsCont>
          <ShowListingsButton
            variant="contained"
            size="large"
            color="primary"
            fullWidth
            onClick={toggleDrawer}
          >
            Show listings
          </ShowListingsButton>
          <Loader open={isLoading} position="fixed" />
        </Drawer>
      </>
    );
  }
);
